customProfession = {
    prof_uid: false,
    otherOpen: false,
    oldSelect: false,
    selectParent: false,
    rowType: false,
    userID: false,
    currentProfessions: [],
    newContent: false,
    realSelect: false,
    isEdit: false
};

function getDepProf(callback) {
    callback = (typeof callback === 'undefined') ? function() {} : callback;
    $.getJSON('/api/v1/professions', function(data) {
        professions = data.professions;
        departments = data.departments;
        callback();
    });
}

function deleteCustomProfession(event, element) {
    (event.preventDefault) ? event.preventDefault(): event.returnValue = false;
    (event.stopPropagation) ? event.stopPropagation(): event.returnValue = false;
    var valueProf = $(element).parent().attr('rel');
    var profIndex = $(element).parent().parent().attr('data-index');
    $('body').append('<div class="overlay"></div>');
    $('#deleteProfession').empty().html('Are you sure you want to delete the profession: ' + $(element).closest('li').text());
    $('#deleteProfession').dialog({
        height: 140,
        draggable: false,
        resizable: false,
        appendTo: 'body',
        close: function(event, ui) {
            $('.overlay').remove();
        },
        buttons: {
            No: function() {
                $(this).dialog("close");
                $(this).dialog("destroy");
                return false;
            },
            Yes: function() {
                var profInUse = false;
                $('.usr_prof').each(function(){
                    if($(this).val() == valueProf) profInUse = true;
                });
                if(profInUse)
                {
                    $(this).dialog("close");
                    $(this).dialog("destroy");
                    popUpMsg('This profession is in use. Unable to delete.');
                    return false;
                }
                $.post('/api/v1/professions/'+valueProf, {'_method': 'delete'}, function(data) {
                    if(data.status = 'fail')
                    {
                        popUpMsg('This profession is in use. Unable to delete.');
                        return false;
                    }
                    else
                    {
                        $('.usr_prof option[value="' + valueProf + '"]').remove();
                        if($('.usr_prof').val() == valueProf) {
                            $('.usr_prof').val(0);
                            $('.selectric p').text('Choose Profession');
                        }
                        getDepProf(function(){
                            $('.usr_prof').selectric('refresh');
                        });
                        if(data.error){
                            popUpMsg('Failed to load professions.');
                        }
                    }
                }, 'json');
                $('.usr_prof').each(function(){
                    if($(this).val() == valueProf) {
                        $(this).val(0);
                    }
                });
                $('.usr_prof').selectric('refresh');
                $('.selectric-group').find('li[data-index="'+profIndex+'"]').remove();
                $(this).dialog("close");
                $(this).dialog("destroy");
            },
        }
    });
    $('.ui-dialog-buttonset button, .ui-dialog-buttonset button > span').removeClass().attr('role', '').attr('aria-disabled', '');
};

function showEditCustomProfession(event, element) {
    (event.preventDefault) ? event.preventDefault(): event.returnValue = false;
    buildProfessionDepartment();
    if (customProfession.isEdit) {
        customProfession.isEdit = true;
        customProfession.realSelect = $(element).closest('.selectric-items').siblings('.selectric-hide-select').children('.usr_prof');
        customProfession.selectParent = $(element).closest('.dash_cell');
        customProfession.oldSelect = $(customProfession.selectParent).children();
        customProfession.rowType = $(element).closest('.indicator_row').data('user-type');
        customProfession.userID = $(element).closest('.indicator_row').attr('rel');
        customProfession.prof_uid = $(element).parent().attr('rel');
        $(customProfession.realSelect).find('option[value="' + customProfession.prof_uid + '"]').prop('selected', true);
        $('.usr_prof').selectric('refresh');
        $(customProfession.realSelect).change();
    }
    customProfession.otherOpen = true;
    var input = '<input type="text" id="prof_custom" name="prof_custom" data-index="'+$(element).parent().parent().attr('data-index')+'" value="' + (customProfession.isEdit ? professions[customProfession.prof_uid].title : '') + '" placeholder="Enter Profession">';
    var helper = '<div class="defPop" id="other_profession_pop"><div class="onlyRelWrap"><span class="pop-content"><p style="font-weight: bold; font-size: 16px;">Enter Profession name</p><br><p class="text-center"><button id="cancel_custom_profession" class="button-style-2 btn-xs">Cancel</button> <button id="save_custom_profession" class="button-style-2 btn-xs">Save</button></p><span id="error_message"></span></span></div></div>';
    $(customProfession.oldSelect).hide();
    customProfession.newContent = $(input + helper).appendTo(customProfession.selectParent);
    $('#prof_custom').focus();
    $('#other_profession_pop').css({
        left: '0',
        width: '100%',
        bottom: '33px',
        top: 'auto',
        'z-index': '999999',
        'box-sizing': 'border-box'
    });
    $('#other_profession_pop').css('display', 'block').stop().animate({
        'opacity': 1
    }, 300);
    if (customProfession.isEdit) {
        $(customProfession.selectParent).nextAll().children('table').removeClass('indMonthTable').addClass('customProfessionCategory');
    } else {
        $(customProfession.selectParent).nextAll().children('table').removeClass('indMonthTable').addClass('customProfessionCategory').find('td').removeClass().addClass('auto-style517');
    }
    return false;
}

function buildProfessionDepartment() {
    departmentsFormatted = {};
    $.each(departments, function(index, department) {
        department.professions = [];
        departmentsFormatted[department.uid] = department;
    });
    $.each(professions, function(prof_uid, profession) {
        $.each(departmentsFormatted, function(dep_uid, department) {
            if ($.inArray(dep_uid, profession.default_departments) != -1) {
                departmentsFormatted[dep_uid].professions.push(profession.title);
            }
        });
        customProfession.currentProfessions.push(profession.title.toLowerCase());
    });
}
$(document).ready(function(){
    var changed = [];
	if(demo || (!demo && adminPrivilages)){
		$('.indMonthTable').click(setIndicatorCategory);
	}

    $('#auto_assign').change(function(){
        var autoAssignValue = $(this).val();

        $.post('auto-assign', {autoassign: autoAssignValue}, function(data) {
            // if(data.error){
            //     popUpMsg('Failed to change autoassign.');
            // }
        }, 'json');

    });


	$('.hover').hover(
		function() {
			var that = $(this);
			var right = ($(that).parent().width() - $('.c').position().left) - 5;
			$('#member_type_hover').css({left: 'auto', right: right+'px', width: 'auto', bottom: '-10px', top: 'auto', 'z-index': '999999', 'border-color': $(that).data('border')});
			$('#member_type_hover').css('display','block').stop().animate({'opacity':1},300);
			$('#member_type_hover').find('.pop-content').empty().html($(that).data('content'));
		},
		function() {
			$('#member_type_hover').stop().animate({'opacity':0},300,function() { $(this).css('display','none'); });
		}
    );

    $('.showRegPop').hover(
		function() {
			var that = $(this);
			$(that).next('.defPop').css('display','block').stop().animate({'opacity':1},300);
		},
		function() { 
			$(this).next('.defPop').stop().animate({'opacity':0},300,function() { $(this).css('display','none'); });
		}
	);
    
    $('.aaUser').click(function(){
        var usr_name = $(this).attr('data-full-name'),
            memberRow = $('#ind_row_'+$('.usr_uid-' + $(this).attr('rel')).val());
            memberType = memberRow.attr('data-user-type');
        popUpConfMsg('Are you sure you want to automatically assign indicators for ' + usr_name + '?', function(){
            $.each($('.indMonthTable', memberRow), function(i, e) {
                var updateCommittees = function() {
                    if(!$('td', e).hasClass('auto-style517')) {
                        $(e).click();
                        setTimeout(function() { $(e).click(); }, (30 * i));
                        setTimeout(function() { $(e).click(); }, (60 * i));
                    }
                };
                setTimeout(updateCommittees, (150 * i));
            });
        });
    });

    $('.indicator_row .usr_prof, .indicator_row input').change(function(){
        changed.push($(this).parents('.indicator_row').attr('rel'));
    });

    $('.indicator_row .usr_email').on('keyup', function(){
        if($(this).parent().parent().attr('id') !== 'ind_row_users_NEW' || $(this).parent().parent().attr('id') !== 'ind_row_support_NEW' || demo === true || $(this).val().length < 3) return;
        var $input = $(this);
        $.ajax({
            url: '/facility/members/manage-users/checkUserExists',
            data: {email: $(this).val()},
            method: 'POST'
        }).fail(function(data, status, xhr){
            if(data == 'Unauthorized' || xhr.status == 401){
                demo = true;
            }
        }).done(function(data, status, xhr){
            if(data.user != null)
            {
                var $row = $input.parent().parent();
                $row.find('.usr_fname').val(data.user.first_name);
                $row.find('.usr_lname').val(data.user.last_name);
                $row.find('.usr_password').attr('type', 'password').val('fakePassword');
            }
        });
    });

	$('.topRight, .indicator_desc_close').click(function() {
		$(this).parent().parent().stop().animate({'opacity':0},300,function() { $(this).css('display','none'); });
	});

	if((navigator.userAgent.match(/iPhone/i))) {

		$('#manage_users_key li').css('font-size', '10px');

	}

	$('.deleteUser').click(function(){
		if(!adminPrivilages && !demo){
			popUpMsg('Only committee chairpersons can delete a user.');
			return false;
		}else if(demo){
			needsToRegisterError('modify users.')
			return false;
		}

		var delete_usr_uid = $(this).attr('rel'),
			usr_name = $(this).attr('data-full-name'),
			memberType = $('#ind_row_'+$('.usr_uid-' + $(this).attr('rel')).val()).attr('data-user-type');
		popUpConfMsg('Are you sure you want to delete ' + usr_name + '?', function(){
			var postData = {
				ss: (memberType == 'support' ? 1 : 0),
				_method: 'delete'
			};
			$.ajax({
				url: '/facility/members/manage-users/'+delete_usr_uid,
				data: postData,
				method: 'POST',
			}).fail(function(data, status, xhr){
				if(data == 'Unauthorized' || xhr.status == 401){
					demo = true;
					needsToRegisterError('make changes to member departments.');
				}else if(data == 'Forbidden' || xhr.status == 403){
					popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to departments.');
				}else{
					unknownError();
				}
			}).done(function(data, status, xhr){
				window.location.reload();
			});
		});
	});

    $('.users-row input').focusin(function(){
        if(!demo && !adminPrivilages && $(this).parent().parent().attr('rel') != curr_usr_id){
		 	popUpMsg('Only committee chairpersons can change other members accounts.');
		 	return false;
		 }
    });


    $('.usr_prof').selectric({
        arrowButtonMarkup: '<img src="/assets/images/Down-Arrow-Gray.png"/>',
        disableOnMobile: false,
        optionsItemBuilder: function(itemData, element, index) {
            if ($(itemData.element).attr('rel') == 'custom' && adminPrivilages) {
                return '<span>' + $(itemData.element).text() + '</span>' + '<div class="option-buttons" rel="' + $(itemData.element).val() + '"><a href="#" class="edit_link"><i class="icon-pencil" data-icon="k"></i></a> <a href="#" class="delete_link"><i class="icon-trash-can" data-icon="T"></i></a></div>';
            } else {
                return '<span>' + $(itemData.element).text() + '</span>';
            }
        },
        onOpen: function() {
            $('.option-buttons, li a').unbind('click');
            $('.edit_link').click(function(){
                customProfession.isEdit = true;
                showEditCustomProfession(event, this);
            });
            $('.delete_link').click(function(){deleteCustomProfession(event, this)});
            if (!demo && !adminPrivilages && $(this).closest('.users-row').attr('rel') != curr_usr_id) {   // FIX THIS FOR MULTIPLE ROWS
                popUpMsg('Only committee chairpersons can change other members accounts.');
                return false;
            }
        }
    });
    getDepProf();
    $('.usr_prof').on('change', function() {
        var selectedProfession = $(this);
        if ($(selectedProfession).val() != '0' && $(selectedProfession).val() != 'other') {
            $(this).removeClass('blank');
            if (adminPrivilages) {
                var selectedDefault = professions[$(selectedProfession).val()];
                var closestIndicators = $(this).closest('.dash_cell').siblings('.dash_cell').find('table');
                $(closestIndicators).find('td').removeClass();
                $.each(selectedDefault.default_departments, function(index, value) {
                    var thisIndicatorTD = $(closestIndicators).find('td[rel="' + value + '"]');
                    var defaultPermission = selectedDefault.default_permissions[index];
                    if (defaultPermission == '3') {
                        $(thisIndicatorTD).addClass('auto-style552');
                    } else if (defaultPermission == '2') {
                        $(thisIndicatorTD).addClass('auto-styleAlert');
                    }
                });
                var AllIndicatorsTD = $(closestIndicators).find('td');
                //set default classes
                $.each(AllIndicatorsTD, function(index, element) {
                    if (!$(element).hasClass('auto-style552') && !$(element).hasClass('auto-styleAlert')) {
                        $(element).addClass('auto-style517');
                    }
                });
            }
            // if ($(this).attr('rel') != 'NEW') {
            //     var userType = $(this).closest('.users-row').data('user-type');
            //     updateUser($(this).attr('rel'), true, userType);
            // }
        }
        if ($(selectedProfession).val() == 'other') {
            customProfession.realSelect = $(this);
            customProfession.selectParent = $(this).closest('.dash_cell');
            customProfession.oldSelect = $(customProfession.selectParent).children();
            customProfession.rowType = $(this).closest('.indicator_row').data('user-type');
            customProfession.userID = $(this).closest('.indicator_row').attr('rel');
            showEditCustomProfession($(this));
        }
    });

    function removeCustomProfessionContent() {
        $('#other_profession_pop').css('display', 'block').stop().animate({
            'opacity': 0
        }, 300, function() {
            $(customProfession.newContent).remove();
            $(customProfession.oldSelect).show();
            $(customProfession.selectParent).nextAll().children('table').removeClass('customProfessionCategory').addClass('indMonthTable');
            customProfession.otherOpen = false;
            customProfession.prof_uid = false;
            customProfession.oldSelect = false;
            customProfession.selectParent = false;
            customProfession.rowType = false;
            customProfession.userID = false;
            customProfession.newContent = false;
            customProfession.realSelect = false;
            customProfession.isEdit = false;
        });
    }
    $(document).on('click', '#cancel_custom_profession', function(e) {
    	e.preventDefault();
        removeCustomProfessionContent();
        $(customProfession.realSelect).find('option[value="0"]').prop('selected', true);
        $('.usr_prof').selectric('refresh');
        return false;
    });
    $(document).on('click', '#save_custom_profession', function(e) {
        e.preventDefault();
        if(demo){
        	popUpMsg('To update your profile please <a href="/register">register</a>.')
        	return false;
        }
        $('#error_message').empty();
        if (!customProfession.isEdit) {
            if ($.inArray($('#prof_custom').val().toLowerCase(), customProfession.currentProfessions) != -1) {
                $('#other_profession_pop .pop-content #error_message').append('<br>That profession already exists.');
                return;
            }
        }
        if ($('#prof_custom').val() == '') {
            $('#other_profession_pop .pop-content #error_message').append('<br>You must enter a profession title.');
            return;
        }
        $('#other_profession_pop').closest('#table_header').find('.updateAllUsers').click();
        var newProfTitle = $('#prof_custom').val();
        var postData = {
            usr_uid: customProfession.userID,
            title: newProfTitle
        };
        var index = $('#prof_custom').attr('data-index');
        if(customProfession.isEdit){
        	postData['_method'] = 'put';
        }
        $.post('/api/v1/professions'+(customProfession.isEdit ? '/'+customProfession.prof_uid : ''), postData, function(data) {
            if (!customProfession.isEdit) {
                $('optgroup').append('<option value="' + data.id + '" rel="custom">' + $('#prof_custom').val() + '</option>');
            } else {
                var currentTitle = professions[customProfession.prof_uid].title;
                professions[customProfession.prof_uid].title = newProfTitle;
                $('optgroup').find('option[value="'+customProfession.prof_uid+'"]').text(newProfTitle);
                $('.selectric p').each(function(){
                    if($(this).text() == currentTitle) $(this).text(newProfTitle);
                });
                $('.selectric-group li[data-index="' + parseInt(index) + '"]').find('span').text(newProfTitle);
            }
            $('.usr_prof').selectric('refresh');
            $(customProfession.realSelect).find('option').prop('selected', false);
            $(customProfession.realSelect).find('option[value="' + data.id + '"]').prop('selected', true);
            removeCustomProfessionContent();
            customProfession.otherOpen = false;
            $(customProfession.newContent).remove();
            $(customProfession.oldSelect).show();
            getDepProf(function() {
                if(!customProfession.isEdit) $('.usr_prof').selectric('refresh');
                $(customProfession.realSelect).trigger('change');
            });
            if(data.error){
                popUpMsg('Failed to load professions.');
            }
        }, 'json');
        return false;
    });
    $('.updateAllUsers').click(function(e) {
        e.preventDefault();
        // var userType = $('.users-row').data('user-type'); //Fix for multiple users
        var userType = $(this).data('user-type'); //Fix for multiple users
        if(demo){
        	needsToRegisterError('update users.');
        	return false;
        }
        if (!$('.users-row[data-user-type="' + userType + '"]').closest('form').valid()) {
            return false;
        }
        $.each($('.users-row[data-user-type="' + userType + '"]'), function(index, element) {
            if (!adminPrivilages) {
                if ($(this).attr('rel') != curr_usr_id) {
                    return true;
                }
            }
            if ($(this).attr('id') != 'ind_row_users_NEW' && $(this).attr('id') != 'ind_row_support_NEW') {
                if($.inArray($(this).attr('rel'), changed) > -1) {
                    if(changed.indexOf($(this).attr('rel')) == (changed.length - 1)){
                        updateUser($(this).attr('rel'), true, userType);
                    }else{
                        updateUser($(this).attr('rel'), false, userType);
                    }
                }
            } else {
                var firstName = $(element).find('.usr_fname').val(),
                    lastName = $(element).find('.usr_lname').val(),
                    username = $(element).find('.usr_email').val(),
                    password = $(element).find('.usr_password').val();
                var addNewUser = false;
                if (firstName != '' || lastName != '' || username != '' || password != '') {
                    addNewUser = true;
                }
                if (addNewUser) {
                    if (!$(this).valid()) {
                        return true;
                    }
                    updateUser('NEW', true, userType);
                } else {
                    $(this).tooltipster('hide');
                }
            }
        });
    });

    function splitArray(a, n) {
        var len = a.length,
            out = [],
            i = 0;
        while (i < len) {
            var size = Math.ceil((len - i) / n--);
            out.push(a.slice(i, i += size));
        }
        return out;
    }
    $('.indicator-category-title').click(function(e) {
        e.preventDefault();
        buildProfessionDepartment();
        if ($(this).data('open') == 'false' || typeof $(this).data('open') === 'undefined') {
            $('.indicator-category-title').data('open', 'false');
            $('.indicator-category-professions-div').animate({
                opacity: 0
            }, 300, function() {
                $(this).remove();
            });
            $(this).parent().css('position', 'relative');
            var html = '<div class="indicator-category-professions-div ' + ($(this).hasClass('title-top') ? 'title-top' : '') + '">';
            html += '<p style="position: relative;"><strong>' + departmentsFormatted[$(this).attr('rel')].name + '</strong><span style="display: block; position: absolute; right: 10px; top: 6px;"><i class="icon-cancel-circled" data-icon="i" style="font-size: 20px;"></i></span></p>';
            departmentsFormatted[$(this).attr('rel')].professions.sort();
            var columnsFormatted = splitArray(departmentsFormatted[$(this).attr('rel')].professions, 3);
            for (var c = 0; c < columnsFormatted.length; c++) {
                html += '<ul class="align_left" style="display: inline-block; width: 33%;margin: 0px auto;">';
                for (var i = 0; i < columnsFormatted[c].length; i++) {
                    html += '<li style="font-size: 12px; margin: 10px 0;">' + columnsFormatted[c][i] + '</li>';
                }
                html += '</ul>';
            }
            html += '</div>';
            $(html).css('opacity', '0').appendTo(this).animate({
                opacity: 1
            }, 200);
            $(this).data('open', 'true');
        } else if ($(this).data('open') == 'true') {
            $('.indicator-category-title').data('open', 'false');
            $('.indicator-category-professions-div').animate({
                opacity: 0
            }, 200, function() {
                $(this).remove();
            });
        }
    });
    $('.users-row').tooltipster({
        trigger: 'custom',
        onlyOne: true,
        animation: 'grow',
        position: 'bottom'
    });
    $.validator.addMethod("valueNotEquals", function(value, element, arg) {
        if ($(element).closest('.users-row').attr('id') != 'ind_row_users_NEW' || $(element).closest('.users-row').attr('id') != 'ind_row_support_NEW') return true;
        return arg != value;
    }, "Value must not equal arg.");
    $.validator.addMethod("pwcheck", function(value) {
        return /^[A-Za-z0-9\d=!\-@._*]*$/.test(value)
            && /[a-z]/.test(value)
            && /\d/.test(value)
    });


    var updaterules = {
                  'usr_fname': 'required',
                  'usr_lname': 'required',
                  'usr_email': {
                      'required': true,
                      'email': true,
                  },
                  'usr_password': {
                      'required': 'password'
                  },
                  'usr_prof': {
                      'valueNotEquals': "0"
                  }
                }


    var newrules = $.extend(true, {}, updaterules);
    newrules.usr_password.pwcheck = true;
    newrules.usr_password.minlength = 8;


    createValidatorRow('#users-form', false, updaterules);
    createValidatorRow('#support-form', false, updaterules);
    createValidatorRow('#ind_row_users_NEW[data-user-type="users"]', true, newrules);
    createValidatorRow('#ind_row_support_NEW[data-user-type="support"]', true, newrules);


    function createValidatorRow(element, password, rules) {
        var validator = $(element).validate({
            ignore: [],
            rules: rules,
            success: function(label, element) {
                if (validator.numberOfInvalids() == 0) {
                    $(element).closest('.users-row').tooltipster('hide');
                }
            },
            errorPlacement: function(error, element) {
                if ($(error).text() != '') {
		    var message = "";
		    if ($(error).attr('id') == 'usr_password-error') {
			message = 'Please select a password that is 8+ characters in length and contains numbers and letters';
		    }
                    else if ($(error).attr('id') == 'usr_email-error') {
			message = 'Please enter a valid email address';
		    }
		    else {
			message = "All fields are required";
	            }
                    $(element).closest('.users-row').tooltipster('update', message);
                    $(element).closest('.users-row').tooltipster('show');
                }
            },
        });
    }
});

function setIndicatorCategory() {
    if (customProfession.otherOpen) {
        return;
    }
    var committees = new Array(),
        perms = new Array(),
        i = 0,
        ind_uid = $(this).attr('rel'),
        thisChildTD = $(this).children('tbody').children('tr').children('td');
    if (!adminPrivilages && !demo) {
        popUpMsg('Only committee chairpersons can set indicator categories.');
        return false;
    }
    if ($(thisChildTD).hasClass('auto-style552')) {
        $(thisChildTD).removeClass('auto-style552').addClass('auto-styleAlert');
    } else if ($(thisChildTD).hasClass('auto-styleAlert')) {
        $(thisChildTD).removeClass('auto-styleAlert').addClass('auto-style517');
    } else {
        $(thisChildTD).removeClass('auto-style517').addClass('auto-style552');
    }
    $('.indMonthTable[rel="' + ind_uid + '"] td, .customProfessionCategory[rel="' + ind_uid + '"] td').each(function() {
        if ($(this).hasClass('auto-style552') || $(this).hasClass('auto-styleAlert') || $(this).hasClass('auto-styleBlue')) {
            val = Number($(this).attr('rel'));
            committees[i] = val;
            if ($(this).hasClass('auto-styleAlert')) {
                perms[i] = 2;
            } else if ($(this).hasClass('auto-styleBlue')) {
                perms[i] = 4;
            } else {
                perms[i] = 3;
            }
            i++;
        }
    });
    if (ind_uid != 'NEW' && !demo) {
        var memberType = $('#ind_row_' + $('.usr_uid-' + ind_uid).val()).attr('data-user-type');
        var thisUserID = $('.usr_uid-' + ind_uid).val();
        if(thisUserID == ''){
        	unknownError();
        	return;
        }
        var postData = {
        	departments: committees,
        	privs: perms,
        	ss: (memberType == 'support' ? 1 : 0),
        	_method: 'put'
        };
        $.ajax({
        	url: '/facility/members/manage-users/departments/'+thisUserID,
        	data: postData,
        	method: 'POST',
        }).fail(function(data, status, xhr){
        	if(data == 'Unauthorized' || xhr.status == 401){
        		demo = true;
        		needsToRegisterError('make changes to member departments.');
        	}else if(data == 'Forbidden' || xhr.status == 403){
        		popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to departments.');
        	}else{
        		unknownError();
        	}
        });
    }
}

function updateUser(rowID, showMessage, user_type) {
	if(demo){
		return false;
	}
  	showMessage = typeof showMessage !== 'undefined' ? showMessage : true;
  	user_type = typeof user_type !== 'undefined' ? user_type : 'users';

	var firstName = $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_fname').val(),
	  lastName = $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_lname').val(),
	  email = $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_email').val(),
	  profession = $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_prof :selected').val(),
	  committees = [],
	  perms = [],
	  i = 0;

	if(firstName == '' || email == '' || lastName == '') {
		return false;
	}

	if(rowID === 'NEW' && $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_password').val() == '') {
	  popUpMsg('A password is required.');
	  return false;
	}

	$('.users-row[data-user-type="'+user_type+'"] .indMonthTable[rel="'+rowID+'"] td').each(function() {
	   if($(this).hasClass('auto-style552') || $(this).hasClass('auto-styleAlert') || $(this).hasClass('auto-styleBlue')) {
			val = $(this).attr('rel');
			committees[i] = val;
			if($(this).hasClass('auto-styleAlert')) {
				perms[i] = 2;
			} else if($(this).hasClass('auto-styleBlue')) {
				perms[i] = 4;
			} else {
				perms[i] = 3;
			}
			i++;
	   }
	});

	$('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + ' input.error').removeClass('error');

	var postData = {
		first_name: firstName,
		last_name: lastName,
		email: email,
		departments: committees,
		privs: perms,
		prof_uid: profession,
		is_surveyor: $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_is_mock_surveryer').val()
	};
	var passVal = $('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + '[data-user-type="'+user_type+'"] .usr_password').val();
	if(rowID !== 'NEW'){
		postData['_method'] = 'put';
	}
	if(passVal != ''){
		postData['password'] = passVal;
	}

    console.log(postData);
  	$.ajax({
    	url: '/facility/members/manage-users'+(rowID !== 'NEW' ? '/'+$('#ind_row_' + rowID + '[data-user-type="'+user_type+'"] .usr_uid-' + rowID).val() : ''),
    	data: postData,
    	method: 'POST',
    }).fail(function(data, status, xhr){
        $('.pop_up').remove();
        $('.overlay').remove();
    	if(data == 'Unauthorized' || xhr.status == 401){
    		demo = true;
    		needsToRegisterError('edit members.');
            return status;
    	}else if(data == 'Forbidden' || xhr.status == 403){
    		popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to members.');
            return status;
    	}else if(xhr == 'Unprocessable Entity' || xhr.status == 422){
            popUpMsg('Please enter a password that is at least 6 characters and includes both letters and numbers');
            return status;
        }else if(data.responseText.trim() == 'E-mail taken' || data == 'E-mail taken') {
            popUpMsg('This e-mail is already taken. Please contact Administrator to make this change.');
            return status;
    	}else{
            // console.log(1,data.statusText);
            // console.log(2,status);
            // console.log(3,xhr);
            // console.log(4,data);
            unknownError();
        }
    }).always(function(response, status, xhr){
    	if(typeof response !== "object"){
    		$('#ind_row_' + (rowID == 'NEW' ? user_type + '_' + rowID : rowID) + ' .usr_password').val('');
    	}else{
            console.log(response);
    		var namesToActualElements = {first_name: 'usr_fname', last_name: 'usr_lname', email: 'usr_email', password: 'usr_password'};
            if(response.data['responseText']){
        		var errors = data.responseText;
        		// var errorKeys = Object.keys(errors);
        		// for(var i = 0; i < errorKeys.length; i++){
        		// 	$('#ind_row_' + rowID + ' input[name="'+namesToActualElements[errorKeys[i]]+'"]').addClass('error');
        		// }
            }
    	}
    	if(response.data == 'refresh'){
            window.location.reload();
        }
    }).success(function(data, status, xhr){
            if(data == 'refresh'){
                window.location.reload()
            }
            else if(showMessage){
                $('.pop_up').remove();
                $('.overlay').remove();
                setTimeout(function(){
                    if(!$('.pop_up').length) {
                        popUpMsg('Update Complete');
                        $('#msgClose').off('click').on('click', function(){window.location.reload()});
                    }
                }, 800);
            }
    });
}
